exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.interview-contents[data-v-62b13de8] {\n  margin: auto;\n}\n.interview-contents > *[data-v-62b13de8] {\n    margin-top: 80px;\n}\n.newspaper-img-wrapeer[data-v-62b13de8] {\n  max-width: 560px;\n  margin: auto;\n  margin-top: 80px;\n}\n@media screen and (max-width: 480px) {\n.interview-contents > *[data-v-62b13de8] {\n    margin-top: 40px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62b13de8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LP/organisms/MCSInterviewContents.vue
// module id = eW8p
// module chunks = 3